import React from "react";
import Hero from "components/Hero";
import About from "components/About";
import Contact from "components/Contact";

const Home: React.FC = () => {
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <Hero
        image="/images/Gallery/DSC09887-min.jpg"
        text="Välkommen till Lada Basteskår"
      />

      <About />
      <Contact />
    </div>
  );
};

export default Home;
